import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleEditModulePermissionsModal } from '../../../redux/reducers/rbacReducer';

export const roleModulesDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.attachModules',
        popover: {
          title: 'Attach Modules to Role',
          description:
            'Use this button to attach modules to the selected role. You can select multiple modules and set their permissions also.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editModulePermissions',
        popover: {
          title: 'Edit Module Permissions',
          description:
            'Click here to edit the permissions associated with the selected module. You can update the permissions to control access and functionality for the module.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.removeModuleFromRole',
        popover: {
          title: 'Remove Module from Role',
          description:
            'Use this button to remove a module from the selected role. This action will disassociate the module from the role.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            navigate('/permissions_roles');
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default roleModulesDriverObj;
